import React from "react";
import {
  Modal,
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  useTheme,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const AddLicenseModal = ({
  open,
  onClose,
  formData,
  handleInputChange,
  handleAddLicense,
  handleRippleEffect,
  isEditing,
  type,
  setType,
  licenceType,
}) => {
  const theme = useTheme();

  // Form validation
  const isFormValid =
    formData.expiry_date &&
    type &&
   formData.devices

  const safeLicenceType = licenceType || [];

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "&:focus": { outline: "none" },
      }}
    >
      <Box
        sx={{
          bgcolor: theme.palette.background.paper,
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          width: { xs: "90%", sm: 500 },
          maxHeight: "90vh",
          overflowY: "auto",
          boxShadow: 4,
          outline: "none",
        }}
      >
        {/* Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={3}
          sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}
        >
          <Typography variant="h5" fontWeight={700}>
            {isEditing ? "Edit License" : "Add License"}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Title */}
        <Typography variant="subtitle1" fontWeight={700} mb={2}>
          License Information
        </Typography>

        {/* License Type */}
        <FormControl fullWidth sx={{ mb: 3 }}>
          <InputLabel id="license-type-label">License Type*</InputLabel>
          <Select
            labelId="license-type-label"
            value={type || ""}
            label="License Type*"
            onChange={(e) => setType(e.target.value)}
            MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
          >
            {safeLicenceType.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Expiry Date */}
        <TextField
          type="date"
          label="Expiry Date*"
          value={formData.expiry_date || ""}
          onChange={(e) => handleInputChange("expiry_date", e.target.value)}
          fullWidth
          sx={{ mb: 3 }}
          InputLabelProps={{ shrink: true }}
          error={!formData.expiry_date}
          helperText={!formData.expiry_date ? "Expiry date is required" : ""}
        />

        {/* Numbers Section */}
        <Box display="flex" flexDirection="column" gap={2} mb={3}>
          <TextField
            type="number"
            label="No. Devices"
            value={formData.devices ?? 0}
            onChange={(e) =>
              handleInputChange("devices", Number(e.target.value) || 0)
            }
            fullWidth
            InputProps={{ inputProps: { min: 0 } }}
          />

        </Box>

        {/* Submit Button */}
        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            onClick={(e) => {
              handleRippleEffect(e);
              handleAddLicense();
            }}
            disabled={!isFormValid}
            sx={{
              borderRadius: 3,
              px: 3,
              py: 1.5,
              textTransform: "none",
              fontWeight: 500,
            }}
          >
            {isEditing ? "Update License" : "Add License"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddLicenseModal;
